import FingerprintIcon from '@material-ui/icons/Fingerprint'
import PersonOutlineIcon from '@material-ui/icons/PersonOutline'
import PersonIcon from '@material-ui/icons/Person'
import DriveEtaIcon from '@material-ui/icons/DriveEta'
import LocationCityIcon from '@material-ui/icons/LocationCity'
import ReceiptIcon from '@material-ui/icons/Receipt'
import AssignmentIcon from '@material-ui/icons/Assignment'
import LabelOutlinedIcon from '@material-ui/icons/LabelOutlined'
import FolderIcon from '@material-ui/icons/Folder'
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined'

/**
 * 🛡️ Registro Global de Ícones do SIGEP (Single Source of Truth)
 * 
 * Qualquer alteração de ícone feita aqui se reflete automaticamente:
 * - Nos Cards de Objetos do Caso
 * - No Menu Flutuante de Cadastro (MenuAdd)
 * - Nos resultados da Busca Global (TopBar)
 * 
 * Todos os ícones herdam dinamicamente as cores dos contêineres,
 * garantindo 100% de integridade e suporte nativo para Dark e Light Mode! 🌓🚀
 */
export const ICONES_SISTEMA = {
  VESTIGIO: FingerprintIcon,
  CADAVER: PersonOutlineIcon,
  PERICIANDO: PersonIcon,
  VEICULO: DriveEtaIcon,
  LOCAL: LocationCityIcon,
  REQUISICAO: ReceiptIcon,
  SOLICITACAO: AssignmentIcon,
  LACRE: LabelOutlinedIcon,
  EXAME: DescriptionOutlinedIcon,
  CASO: FolderIcon,
}
